<template>
  <div class="b-calendar" @mouseleave="onMouseLeave">
    <a-calendar
      v-model="selectedDate"
      :defaultValue="defaultDate"
      :mode="mode"
      @select="onSelectDate"
      :disabledDate="getDisabledDate"
      :class="[headerClass]"
    >
      <div slot="headerRender" slot-scope="{ value }">
        <div class="calendar-header">
          <span
            class="icon icon-bor-circle-right"
            @click="headerHandlePrev"
            :class="isDisabledPrev ? 'disabled' : ''"
          ></span>
          <div class="label" @click="headerClickLabel">
            {{ value.format('YYYY年MM月') }}
          </div>
          <span
            class="icon icon-bor-circle-left"
            @click="headerHandleNext"
            :class="disabledNext ? 'disabled' : ''"
          ></span>
        </div>
      </div>
      <div slot="dateFullCellRender" slot-scope="date">
        <div
          class="ant-fullcalendar-date"
          :class="[
            { 'range-selected-day': isSelectedDay(date) },
            { 'range-hover-day': rangeMode && isHoverDay(date) },
            { 'range-start-day': rangeMode && isStartDay(date) },
            { 'range-end-day': rangeMode && isEndDay(date) },
            { 'range-end-day--in-select': rangeMode && rangeStartDate && isEndDay(date) },
            { 'last-month-day': isLastMonthDay(date) },
            { 'next-month-day': isNextMonthDay(date) },
            { 'day-enabled': enableLastMonth || enableNextMonth },
            { 'nothing-stock': !selectedDays.length }
          ]"
          @mouseenter="onMouseOverDate(date)"
          @mouseleave="onMouseOutDate"
        >
          <div class="ant-fullcalendar-value">
            {{ date.date() > 9 ? date.date() : `0${date.date()}` }}
          </div>
          <div class="ant-fullcalendar-content">
            <div class="events">
              <span
                class="room-status room-open"
                v-if="isRoomOpen(date)"
                v-html="dayOpenDecorator(date)"
              ></span>
              <span
                class="room-status room-few-left"
                v-if="isRoomFewLeft(date)"
                v-html="fewLeftDecorator(date)"
              ></span>
              <span
                class="room-status stay-request"
                v-if="isRoomClosed(date) && dayClosedDecorator(date) =='R'"
                v-html="dayClosedDecorator(date)"
              ></span>
              <span
                class="room-status room-closed"
                v-if="isRoomClosed(date) && dayClosedDecorator(date) !='R'"
                v-html="dayClosedDecorator(date)"
              ></span>
              <div class="extra-content price" v-html="dateCellExtraContent(date)"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- <template slot="monthCellRender" slot-scope="month">
        <div v-show="month">
        </div>
      </template> -->
    </a-calendar>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import moment from 'moment'
import { isEmpty } from 'lodash'

export default {
  name: 'b-calendar',
  components: {},
  props: {
    value: {
      default: null
    },
    defaultValue: {
      default: null
    },
    selectedDays: {
      type: Array,
      default: null
    },
    header: {
      type: Boolean,
      default: false
    },
    dayOpens: {
      type: Array,
      default: null
    },
    dayOpenDecorator: {
      type: Function,
      default: () => {
        return '○'
      }
    },
    dayFewLefts: {
      type: Array,
      default: null
    },
    fewLeftDecorator: {
      type: Function,
      default: () => {
        return '△'
      }
    },
    dayCloses: {
      type: Array,
      default: null
    },
    dayClosedDecorator: {
      type: Function,
      default: () => {
        return '×'
      }
    },
    dateCellExtraContent: {
      type: Function,
      default: () => {
        return ''
      }
    },
    format: {
      type: String,
      default: 'YYYY/MM/DD'
    },
    disabledDate: {
      type: Function,
      default: () => {
        return false
      }
    },
    disabledPrev: {
      type: Boolean,
      default: false
    },
    disabledNext: {
      type: Boolean,
      default: false
    },
    rangeMode: {
      type: Boolean,
      default: false
    },
    enableLastMonth: {
      type: Boolean,
      default: false
    },
    enableNextMonth: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedDate: null,
      defaultDate: null,
      mode: 'month',
      dates: [],
      screenDateEl: [],
      hoverDate: null,
      rangeStartDate: null,
      rangeEndDate: null,
      isNotSelectedDate: true,
      monthNumber: null,
    }
  },
  mounted() {
    if (this.defaultValue) {
      this.isNotSelectedDate = false
      this.defaultDate = moment.isMoment(this.defaultValue)
        ? this.defaultValue.clone()
        : moment(this.defaultValue)
    }
    if (this.value) {
      this.isNotSelectedDate = false
      this.selectedDate = moment.isMoment(this.value) ? this.value.clone() : moment(this.value).clone()
    }

    this.screenDateEl = this.$el.querySelector('.ant-fullcalendar-date')
    this.dates = []
    this.monthNumber = moment().month()
  },
  watch: {
    value(val) {
      if ( !val ) return ;
      this.selectedDate = val.clone()
      this.defaultDate = this.selectedDate
      this.isNotSelectedDate = false
    }
  },
  computed: {
    headerClass() {
      if (!this.header) {
        return 'header-hidden'
      }
      return ''
    },
    hoverRange() {
      if (isEmpty(this.selectedDate || isEmpty(this.hoverDate))) return []
      return this.getDaysBetweenDates(this.selectedDays[0], this.hoverDate)
    },
    isDisabledPrev() {
      if(this.selectedDate ){
        const now = moment(new Date())
        return this.selectedDate ? this.selectedDate.isSameOrBefore(now, 'month') : now.isSameOrAfter(now, 'month')
      }
      return this.disabledPrev
    },
  },
  methods: {
    onSelectDate($event) {
      if (this.rangeMode && this.mode === 'month') {
        this.handleSelectRange($event)
      } else {
        this.handleSelectNormal($event)
      }
    },
    getDisabledDate($event) {
      return this.disabledDate($event, {
        mode: this.mode
      })
    },
    handleSelectNormal($event) {
      this.emitSelectDate($event)
    },

    handleSelectRange($event) {
      if (!this.rangeStartDate || moment(this.rangeStartDate).isAfter($event)) {
        this.rangeStartDate = $event
        this.emitSelectDate($event)
      } else {
        this.selectedDate = this.rangeStartDate
        this.rangeEndDate = $event
        this.emitChangeRange()
        this.rangeStartDate = null
        this.rangeEndDate = null
      }
    },
    emitSelectDate($event) {
      if (this.rangeMode) {
        const emitOptions = {
          isRanging: true,
          rangeStartDate: this.rangeStartDate,
          rangeEndDate: this.rangeEndDate
        }
        this.$emit('input', $event, emitOptions)
      } else {
        this.$emit('input', $event)
      }
      if (this.mode === 'year') {
        this.mode = 'month'
      }
    },
    emitChangeRange() {
      let diff = this.rangeEndDate.diff(this.rangeStartDate, 'days')
      if (!diff) {
        diff = this.selectedDays ? this.selectedDays.length - 1 : 1
      }
      const emitOptions = {
        isRanging: false,
        rangeStartDate: this.rangeStartDate,
        rangeEndDate: this.rangeEndDate
      }
      this.$emit(
        'changeRange',
        {
          startDate: this.rangeStartDate,
          endDate: this.rangeEndDate,
          diff
        },
        emitOptions
      )
      if (this.mode === 'year') {
        this.mode = 'month'
      }
    },
    onMouseOverDate($event) {
      this.hoverDate = $event.format(this.format)
    },
    onMouseOutDate() {
      this.hoverDate = null
    },
    onMouseLeave() {
      if (this.rangeMode && this.rangeStartDate && this.selectedDays) {
        this.setDefautlRangeEndDate()
        this.emitChangeRange()
        this.rangeStartDate = null
        this.rangeEndDate = null
      }
    },
    setDefautlRangeEndDate() {
      if (this.rangeMode && this.rangeStartDate && this.selectedDays) {
        const diff = this.selectedDays ? this.selectedDays.length - 1 : 1
        this.rangeEndDate = this.rangeStartDate.clone().add(diff, 'days')
      }
    },
    getDaysBetweenDates(startDate, endDate) {
      const isRevertCheck = moment(startDate).isAfter(moment(endDate))
      const element = isRevertCheck ? moment(endDate) : moment(startDate)
      const end = isRevertCheck ? moment(startDate) : moment(endDate)
      const dateArray = []
      while (element.isSameOrBefore(end)) {
        dateArray.push(element.format(this.format))
        element.add(1, 'days')
      }
      return dateArray
    },
    isHoverDay($event) {
      const date = $event.format(this.format)
      return this.hoverRange.includes(date)
    },
    isStartDay($event) {
      const date = $event.format(this.format)
      return date === this.selectedDays[0]
    },
    isEndDay($event) {
      const date = $event.format(this.format)
      return this.selectedDays && date === this.selectedDays[this.selectedDays.length - 1]
    },
    isSelectedDay($event) {
      if (this.dates.length < 49) {
        this.dates.push($event)
      }
      const checkingDate = $event.format(this.format)
      if (
        this.selectedDays &&
        Array.isArray(this.selectedDays) &&
        this.selectedDays.includes(checkingDate)
      ) {
        return true
      }
      return false
    },
    isRoomOpen($event) {
      const checkingDate = $event.format(this.format)
      if (
        this.dayOpens &&
        Array.isArray(this.dayOpens) &&
        this.dayOpens.includes(checkingDate)
      ) {
        return true
      }
      return false
    },
    isRoomFewLeft($event) {
      const checkingDate = $event.format(this.format)
      if (
        this.dayFewLefts &&
        Array.isArray(this.dayFewLefts) &&
        this.dayFewLefts.includes(checkingDate)
      ) {
        return true
      }
      return false
    },
    isRoomClosed($event) {
      const checkingDate = $event.format(this.format)
      if (
        this.dayCloses &&
        Array.isArray(this.dayCloses) &&
        this.dayCloses.includes(checkingDate)
      ) {
        return true
      }
      return false
    },
    isLastMonthDay(date) {
      if (date && this.selectedDate && date.isBefore(this.selectedDate, 'month')) {
        return true
      }
      return false
    },
    isNextMonthDay(date) {
      if (date && this.selectedDate && date.isAfter(this.selectedDate, 'month')) {
        return true
      }
      return false
    },
    getNeareastAvaibleDate(date) {
      // const checkingDate = date.format(this.format)
    },
    headerHandleNext() {
      if (this.disabledNext) {
        return
      }
      this.screenDateEl = this.$el.querySelector('.ant-fullcalendar-date')
      this.dates = []
      // const dd = this.getNeareastAvaibleDate(this.selectedDate.clone().add(1, 'month'))
      if(!this.selectedDate || this.isNotSelectedDate ){
        this.monthNumber+=1
        this.selectedDate = moment().month(this.monthNumber)
      }else{
         this.$emit('input', this.selectedDate.clone().add(1, 'months'))
      }
    },
    headerClickLabel() {
      this.mode = this.mode === 'month' ? 'year' : 'month'
    },
    headerHandlePrev() {
      if (this.isDisabledPrev) {
        return
      }
      this.screenDateEl = this.$el.querySelector('.ant-fullcalendar-date')
      this.dates = []
      if(!this.selectedDate || this.isNotSelectedDate ){
        this.monthNumber-=1
        this.selectedDate = moment().month(this.monthNumber)
      }else{
        this.$emit('input', this.selectedDate.clone().subtract(1, 'months'))
      }
    }
  }
}
</script>

<style lang="scss">
@import './style.scss';
</style>
